import { render, staticRenderFns } from "./MenuTabs.vue?vue&type=template&id=f03bcc2c"
import script from "./MenuTabs.vue?vue&type=script&lang=js"
export * from "./MenuTabs.vue?vue&type=script&lang=js"
import style0 from "./MenuTabs.vue?vue&type=style&index=0&id=f03bcc2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports